import { SortDescriptor } from "react-aria-components";

import { IDP_GROUP_USERS_COLUMN_ID } from "../constants";
import { IdpGroupViewManagedUser } from "../../types";

export const sortUsers = (items: IdpGroupViewManagedUser[], sortDescriptor: SortDescriptor) => {
  if (!sortDescriptor.column) {
    return items;
  }

  const isAscending = sortDescriptor.direction === "ascending";

  return [...items].sort((a, b) => {
    let valueA: string | undefined;
    let valueB: string | undefined;

    switch (sortDescriptor.column as IDP_GROUP_USERS_COLUMN_ID) {
      case IDP_GROUP_USERS_COLUMN_ID.NAME:
        valueA = a.username;
        valueB = b.username;
        break;
      case IDP_GROUP_USERS_COLUMN_ID.LAST_LOGIN:
        valueA = a.lastLoginTime?.toString() || "";
        valueB = b.lastLoginTime?.toString() || "";
        break;
      case IDP_GROUP_USERS_COLUMN_ID.STATUS:
        valueA = a.status;
        valueB = b.status;
        break;
      case IDP_GROUP_USERS_COLUMN_ID.METHOD:
        valueA = a.loginMethod;
        valueB = b.loginMethod;
        break;
    }

    valueA = valueA || "";
    valueB = valueB || "";

    return isAscending ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
  });
};
